// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import Testable from 'app/common/react/ui/Testable';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  accessibilityModalLabel: string,
  cancelButtonText: string,
  confirmButtonText: string,
  detail: string,
  heading: string,
  onConfirm: () => void,
  onDismiss: () => void,
|};

const ActivityItemConfirmModal = ({
  accessibilityModalLabel,
  cancelButtonText,
  confirmButtonText,
  detail,
  heading,
  onConfirm,
  onDismiss,
}: Props) => (
  <Modal
    accessibilityCloseLabel={i18n._('close', 'accessible label for button to close modal')}
    accessibilityModalLabel={accessibilityModalLabel}
    heading={heading}
    onDismiss={onDismiss}
    size="md"
  >
    <Box>
      <Box padding={4}>
        <Text size="lg">{detail}</Text>
      </Box>
      <Box display="flex" justifyContent="end">
        <Box margin={2}>
          <Testable id="confirm-modal-cancel">
            <Button onClick={onDismiss} text={cancelButtonText} />
          </Testable>
        </Box>
        <Box margin={2}>
          <Testable id="confirm-modal-confirm">
            <Button
              color="red"
              onClick={() => {
                onConfirm();
                onDismiss();
              }}
              text={confirmButtonText}
            />
          </Testable>
        </Box>
      </Box>
    </Box>
  </Modal>
);

export default ActivityItemConfirmModal;
